import React, { ChangeEvent, useEffect } from 'react';
import { WebinarPage } from '../Webinars.types';
import { setType, setCategory, resetFilter } from '../Webinar.slice';
import { useDispatch } from '@store/store';

interface WebinarFilterProps {
  subHeading: string;
  webinarTypes: WebinarPage['WebinarTypesInEnglish'];
  webinarCategories: WebinarPage['CategoriesInEnglish'];
  categoriesFilterLabel: string;
  typesFilterLabel: string;
  filterPlaceholder: string;
}

const WebinarFilter = ({
  webinarTypes,
  webinarCategories,
  categoriesFilterLabel,
  typesFilterLabel,
  subHeading,
  filterPlaceholder = 'All',
}: WebinarFilterProps) => {
  const dispatch = useDispatch();
  const fontColor = 'webinarColorWhite';
  const webinarCategoriesArr = webinarCategories ? Object.entries(webinarCategories) : [];
  const webinarTypesArr = webinarTypes ? Object.entries(webinarTypes) : [];

  useEffect(() => {
    return () => {
      dispatch(resetFilter());
    };
  }, []);

  return (
    <div className='webinar-filter-container'>
      <div className={'filter-heading ' + fontColor}>{subHeading}</div>
      <div className='webinar-filter-section'>
        {webinarCategoriesArr.length > 0 && (
          <div className='filter-industries'>
            <label className={'labelText ' + fontColor} htmlFor='Industries'>
              {categoriesFilterLabel}
            </label>
            <br />
            <select
              id='webinar-select-industry'
              className='webinar-drop'
              name='Industries'
              onChange={(e: ChangeEvent<HTMLSelectElement>) => {
                e.preventDefault();
                dispatch(setCategory(e.target.value));
              }}
            >
              <option value='All'>{filterPlaceholder}</option>
              {webinarCategoriesArr.map(([id, name]) => (
                <option key={id} value={id}>
                  {name}
                </option>
              ))}
            </select>
          </div>
        )}

        <div className='filter-upcoming'>
          <label className={'labelText ' + fontColor} htmlFor='Upcoming'>
            {typesFilterLabel}
          </label>
          <br />
          <select
            id='webinar-select-status'
            className='webinar-drop'
            name='Upcoming'
            onChange={(e: ChangeEvent<HTMLSelectElement>) => {
              e.preventDefault();
              dispatch(setType(e.target.value));
            }}
          >
            <option value='All'>{filterPlaceholder}</option>
            {webinarTypesArr.map(([id, name]) => (
              <option key={id} value={name}>
                {name}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default WebinarFilter;
